export const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const viewportWidth = window.visualViewport?.width || window.innerWidth;

    // 统一用 1024 作为布局切换阈值，避免窄屏窗口仍命中 PC 版。
    const isNarrowScreen = viewportWidth <= 1024;

    const isPhoneUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTabletUA = /iPad|Tablet|PlayBook|Silk/i.test(userAgent);
    const isIPadOSDesktopUA = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;

    if (isPhoneUA || isTabletUA || isIPadOSDesktopUA) {
        return true;
    }

    // 对无法通过 UA 识别的设备，退化为按视口判断（含桌面窄屏场景）。
    return isNarrowScreen;
};
